import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function Pricing() {
  return <section className="py-24 bg-white relative" data-id="element-135">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <motion.div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-[2.5rem] p-8 md:p-12 text-white shadow-2xl relative overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-137">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-rose-500/20 rounded-full blur-3xl" data-id="element-138" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-rose-600/20 rounded-full blur-3xl" data-id="element-139" />

          <div className="relative z-10 text-center" data-id="element-140">
            <div className="inline-block bg-rose-500 text-white font-bold px-4 py-1.5 rounded-full text-sm tracking-wide uppercase mb-8" data-id="element-141">
              Oferta por tiempo limitado
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-142">
              Accedé hoy con 50% OFF
            </h2>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-143">
              <span className="text-gray-400 line-through text-xl mb-2" data-id="element-144">
                Valor total: $119.940
              </span>
              <div className="flex items-baseline gap-2" data-id="element-145">
                <span className="text-6xl md:text-7xl font-bold text-rose-400" data-id="element-146">
                  $17.990
                </span>
                <span className="text-xl text-gray-300 font-medium" data-id="element-147">ARS</span>
              </div>
            </div>

            <div className="bg-white/10 rounded-2xl p-6 max-w-md mx-auto mb-10 backdrop-blur-sm border border-white/10 text-left" data-id="element-148">
              <p className="font-bold text-lg mb-4 text-center" data-id="element-149">Incluye:</p>
              <ul className="space-y-3" data-id="element-150">
                {['Ebook completo', '6 bonos gratis', 'Acceso inmediato de por vida'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-151">
                    <CheckCircle2 className="w-5 h-5 text-rose-400 flex-shrink-0" data-id="element-152" />
                    <span className="text-gray-100 font-medium" data-id="element-153">{item}</span>
                  </li>)}
              </ul>
            </div>

            <CTAButton text="COMPRAR AHORA" subtext="Oferta por tiempo limitado." className="w-full md:w-auto min-w-[300px]" data-id="element-154" />

            <div className="mt-6 flex items-center justify-center gap-4 text-sm text-gray-400" data-id="element-155">
              <span data-id="element-156">🔒 Pago 100% Seguro</span>
              <span data-id="element-157">•</span>
              <span data-id="element-158">⚡️ Acceso Inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}